import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70ab776b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "article_title" }, "展示样式", -1))
const _hoisted_2 = { class: "article_type" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "article_content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "article_content_title" }, "内容设置", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "article_content_tip" }, "添加文章：数量超过5个显示更多，可上下拖拽", -1))
const _hoisted_7 = { class: "article_content_setup" }
const _hoisted_8 = { class: "setup_title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "模块标题", -1))
const _hoisted_10 = { class: "setup_input_length" }
const _hoisted_11 = { class: "setup_title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "最多显示", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 直播间可以无限添加，最多显示的设置只显示在H5页面展示的数量，最多设置5个展示位，超过5个直播间H5展示更多按钮（设置2-3个展示位，添加四个直播间可显示更多按钮，同理设置2-3个展示位直播间只添加2-3个不会显示更多按钮） ", -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "article_name" }
const _hoisted_16 = { class: "article_null" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("页面暂无创建新闻哦，快去内容中心"),
  /*#__PURE__*/_createElementVNode("span", null, "创建"),
  /*#__PURE__*/_createTextVNode("吧~")
], -1))
const _hoisted_18 = { class: "add_modal" }
const _hoisted_19 = { class: "flex info" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "站内页面：", -1))
const _hoisted_21 = { class: "flex info" }

import draggable from 'vuedraggable';
import { ref } from 'vue';
import emitter from '@/utils/mitt';
import { QuestionCircleFilled } from '@ant-design/icons-vue';
import { InputNumber, Tooltip, Modal } from 'ant-design-vue';
import http from '@/api/conentCenter/communal';
import router from '@/router';
import { useDebounce } from '@/hooks/useDebounce';
import { dragDrop } from '@/utils/format/dragDrop';

interface menuItem {
  id: number;
  name: string;
  visible: boolean;
  count: number;
  default: number;
}
interface Item {
  id: number;
  title: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MyArticle_setup',
  props: {
  custom: {},
  labelId: {},
},
  setup(__props) {

const props: any = __props;

const aInputNumber = InputNumber;
const aTooltip = Tooltip;
const aModal = Modal;
const gatewayId = router.currentRoute.value.params.gatewayId;


const myarticle = ref();
myarticle.value =
  props.custom.type == 6 || props.custom.type == 7
    ? { ...props.custom.tabsList[props.labelId].nestedList[0] }
    : { ...props.custom };

const getType = (index: number) => {
  myarticle.value.style = index;
  toVisualization();
};

const toVisualization = () => {
  const custom = { ...props.custom };
  if (props.custom.type == 6 || props.custom.type == 7) {
    custom.tabsList[props.labelId].nestedList[0] = { ...myarticle.value };
    emitter.emit('visualization', custom);
  } else {
    emitter.emit('visualization', myarticle.value);
  }
};
const docModal = ref();
const liveId = ref();
const getLive = (index: number) => {
  liveId.value = index;
};
const addModal = ref({
  modal: false,
  sortId: ref(),
  value2: [],
  sortList: ref<menuItem[]>([]),
  articleList: ref<Item[]>([]),
  selectType: 0,
  keyword: '',
  options: [
    {
      value: 0,
      name: '文章',
    },
    {
      value: 1,
      name: '文章分类',
    },
  ],
});

const showModal = () => {
  addModal.value.modal = true;
  addModal.value.selectType == 0
    ? getPortalArticleList(addModal.value.keyword, (d: any[]) => (addModal.value.articleList = d), 1)
    : getSortList();
};
const current = ref(1);
const last_page = ref();
const popupScroll = () => {
  current.value += 1;
  current.value <= last_page.value &&
    getPortalArticleList(addModal.value.keyword, (d: any[]) => (addModal.value.articleList = d), current.value);
};

// 获取分类列表
const getSortList = () => {
  let params = {
    type: 1,
    portal_id: gatewayId,
  };
  http.get_sort_list({ params }).then((res) => {
    addModal.value.sortList = res.data.data;
    addModal.value.sortId = res.data.data.filter((e: any) => e.default == 1)[0].id;
    addModal.value.value2 = addModal.value.sortId;
  });
};

const getPortalArticleList = useDebounce((keyword: string, callback: any, current: number) => {
  let params = {
    portal_id: gatewayId,
    keyword: keyword,
    page: current,
    page_num: 20,
    sort_id: addModal.value.sortId,
  };
  const currentValue = keyword;
  http.getPortalArticleList({ params }).then((res) => {
    if (currentValue === keyword && addModal.value.selectType == 0) {
      res.data.data.data.forEach((r: any) => {
        addModal.value.articleList.push(r);
      });
      callback(addModal.value.articleList);
    }
    last_page.value = res.data.data.last_page;
    if (addModal.value.selectType == 1) {
      myarticle.value.articleList = res.data.data.data;
      setTimeout(() => {
        toVisualization();
      }, 300);
    }
    addModal.value.selectType = 0;
  });
});

const changeSort = () => {
  addModal.value.articleList = [];
  addModal.value.sortList = [];
  addModal.value.value2 = [];
  addModal.value.selectType == 0
    ? getPortalArticleList(addModal.value.keyword, (d: any[]) => (addModal.value.articleList = d), 1)
    : getSortList();
};

const searchList = (keyword: any) => {
  if (addModal.value.selectType == 0) {
    addModal.value.keyword = keyword;
    addModal.value.sortId = '';
    addModal.value.articleList = [];
    getPortalArticleList(addModal.value.keyword, (d: any[]) => (addModal.value.articleList = d), 1);
  }
};

const saveAdd = () => {
  if (addModal.value.selectType == 0) {
    let arr: any = [];
    addModal.value.value2.forEach((item) => {
      arr.push(addModal.value.articleList.filter((e) => e.id == item)[0]);
      var re = new RegExp('"', 'g');
      var fxg = new RegExp('\\\\', 'g');
      arr.map((e) => {
        if (e.content) {
          e.content = e.content.replace(fxg, '\\\\');
          e.content = e.content.replace(re, '\\"');
        }
      });
      myarticle.value.articleList = arr;
    });
    toVisualization();
  } else {
    addModal.value.sortId = addModal.value.value2;
    myarticle.value.sortId = addModal.value.sortId;
    myarticle.value.articleList = [];
    getPortalArticleList(addModal.value.keyword, (d: any[]) => (addModal.value.articleList = d), 1);
  }
  clear();
};

const delArticleList = (index: number) => {
  myarticle.value.articleList.splice(index, 1);
  toVisualization();
};

const clear = () => {
  addModal.value.value2 = [];
  addModal.value.modal = false;
  addModal.value.sortList = [];
  addModal.value.articleList = [];
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", {
    class: "article",
    ref_key: "docModal",
    ref: docModal
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item) => {
        return _createElementVNode("div", {
          key: item,
          class: _normalizeClass([myarticle.value.style == item ? 'type_btn_click' : '', "type_btn"]),
          onClick: ($event: any) => (getType(item))
        }, [
          _createVNode(_component_svg_icon, {
            "icon-class": item == 1 ? 'myarticle_type' : item == 2 ? 'myarticle_type_one' : 'myarticle_type_two'
          }, null, 8, ["icon-class"])
        ], 10, _hoisted_3)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_a_input, {
            class: "setup_input",
            placeholder: "请输入主标题",
            maxlength: 6,
            value: myarticle.value.title,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((myarticle.value.title) = $event)),
            onChange: toVisualization
          }, {
            suffix: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, _toDisplayString(myarticle.value.title.length) + "/ 6", 1)
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_unref(aInputNumber), {
            value: myarticle.value.most,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((myarticle.value.most) = $event)),
            onChange: toVisualization,
            class: "setup_title_number",
            min: 1,
            max: 10
          }, null, 8, ["value"]),
          _createVNode(_unref(aTooltip), { placement: "left" }, {
            title: _withCtx(() => [
              _hoisted_13
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(QuestionCircleFilled), { class: "setup_title_icon" })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_button, {
          onClick: showModal,
          class: "article_content_btn"
        }, {
          default: _withCtx(() => [
            _createTextVNode("添加文章")
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          style: _normalizeStyle({ height: 42 * myarticle.value.most + 'px' }),
          class: "list_box"
        }, [
          _createVNode(_unref(draggable), {
            list: myarticle.value.articleList,
            handle: ".article_drag",
            animation: 150,
            "item-key": "id",
            onEnd: toVisualization,
            onDrop: _unref(dragDrop)
          }, {
            item: _withCtx(({ element, index }) => [
              (element.title)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "article_content_article",
                    onClick: ($event: any) => (getLive(index))
                  }, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(element.title), 1),
                    _createVNode(_component_svg_icon, {
                      class: "article_delete",
                      "icon-class": "solid_delete",
                      onClick: ($event: any) => (delArticleList(index))
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_svg_icon, {
                      class: "article_drag",
                      "icon-class": "drag"
                    })
                  ], 8, _hoisted_14))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["list", "onDrop"])
        ], 4)), [
          [_directive_infinite_scroll, popupScroll]
        ])
      ]),
      _createVNode(_unref(aModal), {
        visible: addModal.value.modal,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((addModal.value.modal) = $event)),
        centered: "",
        title: "添加文章",
        getContainer: () => docModal.value,
        onOk: saveAdd,
        onCancel: _cache[6] || (_cache[6] = ($event: any) => (clear()))
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_16, [
            _createVNode(_component_svg_icon, {
              class: "myarticle_null",
              "icon-class": "myarticle_null"
            }),
            _hoisted_17
          ], 512), [
            [_vShow, false]
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_a_select, {
                value: addModal.value.selectType,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((addModal.value.selectType) = $event)),
                style: {"width":"200px"},
                onChange: changeSort
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addModal.value.options, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.value,
                      key: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("p", null, "选择" + _toDisplayString(addModal.value.selectType == 0 ? '文章' : '分类') + "：", 1),
              (addModal.value.selectType == 0)
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 0,
                    value: addModal.value.value2,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((addModal.value.value2) = $event)),
                    mode: "multiple",
                    "show-search": "",
                    placeholder: "请选择文章",
                    style: {"width":"200px"},
                    "default-active-first-option": false,
                    "show-arrow": false,
                    "filter-option": false,
                    "not-found-content": null,
                    onSearch: searchList,
                    onPopupScroll: popupScroll
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addModal.value.articleList, (item) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          value: item.id,
                          key: item.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"]))
                : _createCommentVNode("", true),
              (addModal.value.selectType == 1)
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 1,
                    value: addModal.value.value2,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((addModal.value.value2) = $event)),
                    "show-search": "",
                    placeholder: "请选择分类",
                    style: {"width":"200px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addModal.value.sortList, (item) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          value: item.id,
                          key: item.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible", "getContainer"])
    ])
  ], 512))
}
}

})